import { IonCol, IonContent, IonGrid, IonPage, IonRow, IonText } from "@ionic/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import Footer from "../../components/Footer";
import { OptionPages } from '../../models/apiModels';
import { translation } from "../../models/translation";
import { fetchOptions } from "../../services/options_service";

interface UserTProps {
    user?: any
}

const UserTermsP: React.FC<UserTProps> = (props) => {


    const siteText = translation();
    const pathName = useLocation().pathname;

    const isAccountPage = () => {
      if (pathName.indexOf('account') < 0) return false;
      return true
    }
    const [siteOptions, setSiteOptions] = useState<OptionPages>();

    const getOptions = async () => {
        let resp: any = await fetchOptions();
        if (!resp.error) {
            let options: OptionPages = resp.message;
            setSiteOptions(options);
        }
    }
    useEffect(() => {
        getOptions()
    }, []);

    return (
        <IonPage className="pageContent">
            <IonContent>
                <IonGrid className={!isAccountPage()?'sw_sp_md':''}>
                    <IonRow>
                        <IonCol offsetSm="1"  sizeSm="10">
                            <IonRow>
                                <IonCol>
                                    <IonText>
                                    <h1 style={{textTransform:'capitalize'}}>{siteText.footLnkTouTxt}</h1>
                                    </IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                {siteOptions ? <IonCol >
                                    {siteText.lan === "/fr" && <div dangerouslySetInnerHTML={{ __html: siteOptions?.acf.userterms_fr! }}></div>}
                                    {siteText.lan === "/en" && <div dangerouslySetInnerHTML={{ __html: siteOptions?.acf.userterms_en! }}></div>}
                                    {siteText.lan === "/de" && <div dangerouslySetInnerHTML={{ __html: siteOptions?.acf.userterms_de! }}></div>}

                                </IonCol> : ''}
                            </IonRow>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                <Footer></Footer>
            </IonContent>
        </IonPage>)
}

export default UserTermsP;

